const CreditorsIndex = () => import('./outgoing/index.vue');
const CreditorView = () => import('./outgoing/view.vue');

const DebtorsIndex = () => import('./incoming/index.vue');
const OwnerDebtorsIndex = () => import('./incoming/owner-debtors.vue');
const DebtorView = () => import('./incoming/view.vue');
const CustomerStatementPage = () => import('./incoming/customer-statement.vue');
const OwnerStatementPage = () => import('./incoming/owner-statement.vue');
const SupplierStatementPage = () => import('./outgoing/supplier-statement.vue');

const AdvanceIndex = () => import('./advance/index.vue');
const CustomersAdvance = () => import('./advance/customers.vue');
const SuppliersAdvance = () => import('./advance/suppliers.vue');
const AdvanceCreate = () => import('./advance/_pages/create.vue');

// customer receipts
const CustomerReceipts = () => import('./customer-receipts/index.vue');
const ReceiveCustomerPayment = () => import('./customer-receipts/receive-payment.vue');

// supplier payments
const SupplierPayments = () => import('./supplier-payments/index.vue');
const NewSupplierPayment = () => import('./supplier-payments/supplier-payment.vue');


// unallocated payments
const UnallocatedPayments = () => import('./unallocated-payments/index.vue');
const AllocatePayment = () => import('./unallocated-payments/allocate-invoices.vue');

const AuditDebts = () => import('./incoming/audit-debts.vue');
const AuditRct1 = () => import('./incoming/audit-rct1.vue');

export default [
    {
        path: '/audit-debts',
        component: AuditDebts
    },
    {
        path: '/audit-rct1',
        component: AuditRct1
    },
    {
        path: '/unallocated-payments',
        component: UnallocatedPayments
    },
    {
        path: '/allocate-payment/:id',
        component: AllocatePayment
    },
    {
        path: '/customer-receipts',
        component: CustomerReceipts
    },
    {
        path: '/receive-customer-payment',
        component: ReceiveCustomerPayment
    },
    {
        path: '/supplier-payments',
        component: SupplierPayments
    },
    {
        path: '/make-supplier-payment',
        component: NewSupplierPayment
    },
    {
        path: '/creditors',
        component: CreditorsIndex
    },
    {
        path: '/creditors/:id',
        component: CreditorView
    },
    {
        path: '/debtors',
        component: DebtorsIndex
    },
     {
        path: '/owner-debtors',
        component: OwnerDebtorsIndex
    },
    {
        path: '/debtors/:id',
        component: DebtorView
    },
    {
        path: '/customer-statement/:id',
        component: CustomerStatementPage
    },
    {
        path: '/owner-statement/:id',
        component: OwnerStatementPage
    },
    {
        path: '/supplier-statement/:id',
        component: SupplierStatementPage
    },
    {
        path: "/advance/payments",
        component: AdvanceIndex,
        children: [
            {
                path: "",
                component: SuppliersAdvance 
            },
            {
                path: "customers",
                component: CustomersAdvance
            }
        ]
    },
    {
        path: '/create-advance-payment',
        name: 'Create Advance Payments',
        component: AdvanceCreate
    }
]
    
